import { DisclaimerState } from "../../../../../models/state";

const initialState = (): DisclaimerState => ({
    summaryDisclaimers: [],
});

const reducer = (state = initialState()): DisclaimerState => {
    return { ...state };
};

export default reducer;
